import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { EndoscopyAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-endoscopy-slot',
    templateUrl: './endoscopy-slot.component.html',
    styleUrl: './endoscopy-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EndoscopySlotComponent implements SheetSlotComponentBase {

	@Input() action!: EndoscopyAction;
	value = null;

	constructor() {
	}
}